module.exports = __webpack_public_path__ + "img/help-icon3.36162a33.png";